import { Typography } from "@circle-react-shared/uikit/Typography";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Icon } from "@circle-react-shared/Icon";
import { UPSELL_LOCALE_ROOT } from "../../../constants";
import { t } from "@/i18n-js/instance";

interface TitleHeaderProps {
  paywallName: string;
}

export const TitleHeader = ({ paywallName }: TitleHeaderProps) => (
  <div className="flex flex-row gap-x-2 items-center">
    <Typography.LabelMd weight="semibold">
      {t([UPSELL_LOCALE_ROOT, "forms.paywall_selection.title"], {
        paywall_name: paywallName,
      })}
    </Typography.LabelMd>
    <TippyV2
      content={t([UPSELL_LOCALE_ROOT, "forms.paywall_selection.title_tooltip"])}
    >
      <Icon type="question-mark" className="!w-4 !h-4 text-default" />
    </TippyV2>
  </div>
);
